import { render, staticRenderFns } from "./TipoAbonoFormComponent.vue?vue&type=template&id=27471d8a&"
import script from "./TipoAbonoFormComponent.vue?vue&type=script&lang=js&"
export * from "./TipoAbonoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports